/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';


class ExamResultsService {

    getAccountResults(){
        return ApplicationServices.call(Constants.GET_ACCOUNT_RESULTS , {} ).then(function(response){
            Action.update(Constants.GET_ACCOUNT_RESULTS , response.examResults);
            return response;
        });
    }

    getMinorResults(studentUid, testUid){
        return ApplicationServices.call(Constants.GET_MINOR_RESULTS , 
            {studentUid:studentUid, testUid:testUid}).then(function(response){
            Action.update(Constants.GET_MINOR_RESULTS , response.examResults);
            return response;
        });
    }

}

export default new ExamResultsService();